// Rekit uses a new approach to organizing actions and reducers. That is
// putting related actions and reducers in one file. See more at:
// https://medium.com/@nate_wang/a-new-approach-for-managing-redux-actions-91c26ce8b5da

import {
  PRESUPUESTADOR_CLEAN_PDF,
} from './constants';

export function cleanPdf() {
  return {
    type: PRESUPUESTADOR_CLEAN_PDF,
    data: {
      pdf: ""
    },
  };
}

export function reducer(state, action) {
  switch (action.type) {
    case PRESUPUESTADOR_CLEAN_PDF:
      return {
        ...state,
        ...action.data
      };

    default:
      return state;
  }
}
